import { memo } from "react";

import { Root } from "./components";
import { RootProvider } from "./context/root-provider";

import type { CalendarRangeProps } from "./types/calendar-range";
import type { CalendarSingleProps } from "./types/calendar-single";

export type CalendarProps = CalendarSingleProps | CalendarRangeProps;

export const Calendar = memo((props: CalendarProps) => {
	return (
		<RootProvider key={props.numberOfMonths ?? 1} initialProps={props} {...props}>
			<Root />
		</RootProvider>
	);
});

Calendar.displayName = "Calendar";
